export default __webpack_public_path__ + "static/hotel-951600_1280-cc28c50589b406fb3bb6cd3eebf62a94.png";